<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon>
            Visualizar Trilha de Aprendizagem
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  :value="content.nome"
                  label="Descrição da Trilha de Aprendizagem"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="6">
                <v-text-field
                  :value="content.ano"
                  label="Ano do Ciclo"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="content.semestre"
                  label="Semestre do Ciclo"
                  readonly
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <span class="small">Eixos Temáticos</span>
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="eixo in eixoItens" :key="eixo">
                    {{ eixo }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps, TrilhaDeAprendizagem } from '~/commons/classes';

export default {
  props: new DialogProps(TrilhaDeAprendizagem),
  computed: {
    eixoItens() {
      return this.content.eixoItens.map(t => t.descricao)
    }
  }
};
</script>
